export default __webpack_public_path__ + "static/9_28-03a16635ce22a429d7aaf3d63658e7fb.png";